import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Row, Col, Input, Divider } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';
import FilePreviewUploader from '../components/FilePreviewUploader';

function MainSliderAddEdit() {
	const navigate = useNavigate();
	const { editSliderId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [fileList, setFileList] = useState([]);
	const [form] = Form.useForm();

	const get = () => {
		if (!editSliderId) {
			return;
		}
		axios
			.get(`/main-slider`, { params: { _id: editSliderId } })
			.then((result) => {
				console.log(result.data);
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const uplodedFileList = result.data.data[0]?.media?.map((media) => ({
						uid: media._id,
						name: media.mediaTitle,
						status: 'done',
						url: media.mediaPath,
					}));
					if (Array.isArray(uplodedFileList)) {
						setFileList(uplodedFileList);
					}
					form.setFieldsValue(result.data.data[0]);
				}
			})
			.catch(() => {})
			.finally(() => {
				setIsLoading(false);
			});
	};

	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editSliderId) {
					values._id = editSliderId;
				}
				const media = [];
				fileList?.map(({ response }) => {
					if (response?.data?.length) {
						media.push(...response.data);
					}
					return response;
				});
				if (media.length) {
					values.media = media;
				}
				axios({
					method: editSliderId ? 'put' : 'post',
					url: '/main-slider',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/main-slider');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => {
				console.log(e);
			});
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb
				breadcrumbs={[
					{
						link: '/',
						label: 'Home',
					},
					{
						link: '/main-slider',
						label: 'Main Slider',
					},
					{
						label: editSliderId ? 'Edit' : 'Add',
					},
				]}
			/>
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editSliderId ? 'Edit Slider' : 'Add Slider'}</div>
						<div className='page-title-more'>
							<Link to='/main-slider'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave}>
								Save
							</Button>
						</div>
					</div>
					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Row gutter={[16, 0]}>
								<Col sm={24} md={8}>
									<Form.Item label='Slider Heading' name='sliderHeading'>
										<Input placeholder='Enter Slider Heading Here' autoFocus />
									</Form.Item>
								</Col>
								<Col sm={24} md={16}>
									<Form.Item label='Slider Description' name='sliderDescription'>
										<Input style={{ width: '100%' }} placeholder='Enter Slider Description Here' />
									</Form.Item>
								</Col>
								<Col sm={24} md={12}>
									<Form.Item label='Slider Image' name='media'>
										<FilePreviewUploader Form={Form} maxItems={1} fileList={fileList} setFileList={setFileList} aspect={16 / 9} />
									</Form.Item>
								</Col>
							</Row>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}
export default MainSliderAddEdit;
